import ReactDOM from "react-dom";
import { AppWrapper } from "./AppWrapper";
import "./styles/index.css";
const root = document.getElementById("root");
export const wallpaperEl = document.getElementById("wallpaper");
export const htmlEl = document.getElementById("html");
ReactDOM.render(<AppWrapper />, root);